export default __webpack_public_path__ + "static/media/HomeP.5215f0c2.jpg";